/* eslint-disable react/no-array-index-key */
import { useCallback, useEffect, useState } from 'react';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { Grid, Box, Alert, AlertTitle } from '@mui/material';
import ControlledTextField from 'src/shared/components/form/controlledTextField';
import ControlledTextEditor from 'src/shared/components/form/controlledTextEditor';
import { useTranslation } from 'react-i18next';
import { Member } from 'src/modules/member/models/member';
import { People } from '@mui/icons-material';
import { MemberDetailsSummary } from 'src/modules/member/components/memberDetailsSummary';
import { RecipientList } from './recipientList';

type ComposeEmailFormProps = {
  members: Member[];
  disabled?: boolean;
};

export const ComposeEmailForm = (props: ComposeEmailFormProps) => {
  const { members, disabled = false } = props;
  const [membersWithEmail, setMembersWithEmail] = useState<Member[]>([]);
  const [membersWithoutEmail, setMembersWithoutEmail] = useState<Member[]>([]);
  const { t } = useTranslation(['groupMessage', 'common']);

  useEffect(() => {
    setMembersWithEmail(members.filter((x) => !!x.email));
    setMembersWithoutEmail(members.filter((x) => !x.email));
  }, [members]);

  const textEditorInitalized = useCallback(() => {
    return null;
  }, []);

  return (
    <>
      {membersWithEmail.length > 0 && (
        <Alert icon={false} severity='info' sx={{ m: 1, mb: 2 }} elevation={1}>
          {membersWithEmail.length > 1 && (
            <AlertTitle sx={{ display: 'flex', alignItems: 'center' }}>
              <People fontSize='small' sx={{ mr: 1 }} aria-hidden />
              {t('groupMessage:selection.recipients')}&nbsp;<strong>({membersWithEmail.length})</strong>
            </AlertTitle>
          )}
          {membersWithEmail.length === 1 && <MemberDetailsSummary member={membersWithEmail[0]} />}
          {membersWithEmail.length > 1 && <RecipientList members={membersWithEmail} />}
        </Alert>
      )}
      {membersWithoutEmail.length > 0 && (
        <Alert icon={false} severity='warning' sx={{ m: 1, mb: 2 }} elevation={1}>
          <AlertTitle sx={{ display: 'flex', alignItems: 'center' }}>
            <People fontSize='small' sx={{ mr: 1 }} aria-hidden />
            {t('groupMessage:selection.recipientsWithoutEmail')}&nbsp;<strong> ({membersWithoutEmail.length})</strong>
          </AlertTitle>
          <RecipientList members={membersWithoutEmail} />
        </Alert>
      )}
      {membersWithEmail.length > 0 && (
        <Box sx={{ p: 1 }}>
          <GridWrapper>
            <Grid item xs={12}>
              <ControlledTextField
                name='subject'
                required
                disabled={disabled}
                label={t('groupMessage:formFields.subject')}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextEditor name='body' initCallback={textEditorInitalized} disabled={disabled} />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField
                name='sender'
                required
                disabled={disabled}
                label={t('groupMessage:formFields.sender')}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField
                name='senderTitle'
                required
                disabled={disabled}
                label={t('groupMessage:formFields.senderTitle')}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </GridWrapper>
        </Box>
      )}
    </>
  );
};
